// The wait-estimate accuracy report: the pure part.
import type { EstimateRow } from '../lib/estimate'
import type { StaffLanguage } from '../lib/staffText'
import { duration } from './insightCalc'

/** The mean error with its sign: "+3 min" waited longer than told, "−2 min" less. */
export function signedDuration(sec: number, lang: StaffLanguage): string {
  if (sec === 0) return duration(0, lang)
  return (sec > 0 ? '+' : '−') + duration(Math.abs(sec), lang)
}

/** The share of waits told from today's pace, 0–1; null when no row says what it was based on. */
export function liveShare(r: Pick<EstimateRow, 'live' | 'configured'>): number | null {
  const told = r.live + r.configured
  return told > 0 ? r.live / told : null
}

/** The queue a row is about, by name, else code. */
export function queueLabel(r: Pick<EstimateRow, 'queueName' | 'queueCode'>): string {
  return r.queueName || r.queueCode || '—'
}
